export default {"src":"/_next/static/media/Group 48097639.f0012b0e.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};